import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const LandingNavbar = ({ stickyTop = false, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div>
      <nav className="navbar navbar-expand-lg ">
        <div className="container-fluid">
          <div className="row">
            <div>
              <Link to="/">
                <img
                  id="main-logo"
                  className="mr-1"
                  style={{ maxWidth: "50px", margin: 25 }}
                  src={require("../../../images/bitcoin-live/logo.png")}
                  alt="Bitcoin Live"
                />
              </Link>
            </div>
            <div
              style={{
                display: "flex",
                flexFlow: "column",
                justifyContent: "center"
              }}
            >
              <div
                style={{
                  fontStyle: "normal",
                  fontWeight: "bold",
                  fontSize: "18px",
                  lineHeight: "22px",
                  color: "white"
                }}
              >
                BITCOIN
              </div>
              <div
                style={{
                  fontStyle: "normal",
                  fontWeight: "bold",
                  fontSize: "14px",
                  lineHeight: "17px",
                  color: "#FAA61A"
                }}
              >
                LIVE
              </div>
            </div>
          </div>
          <button
            className="navbar-toggler float-right custom-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbar9"
            onClick={toggle}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className={
              isOpen
                ? "navbar-collapse collapse visible"
                : "navbar-collapse collapse"
            }
            id="navbar9"
            style={{ justifyContent: "center" }}
          >
            <ul className="navbar-nav">
              <li className="nav-item">
                <a className="nav-link c-nav-item" href="/blogs/public">
                  Blog
                </a>
              </li>
              <li className="nav-item ">
                <a className="nav-link c-nav-item" href="/blogs/premium">
                  Member
                </a>
              </li>
              <li className="nav-item ">
                <a className="nav-link c-nav-item" href="/alerts">
                  Alerts
                </a>
              </li>
              <li className="nav-item ">
                <a className="nav-link c-nav-item" href="/analysts">
                  Analysts
                </a>
              </li>
              <li className="nav-item ">
                <a className="nav-link c-nav-item" href="/education">
                  Education
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link c-nav-item c-nav-item-login"
                  href="/login"
                >
                  Login
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

const style = {
  link: {
    margin: 25,
    paddingTop: "10px",
    color: "white",
    fontWeight: "500",
    fontSize: "14px"
  },
  login: {
    margin: 25,
    color: "white",
    fontWeight: "500",
    fontSize: "14px",
    border: "1px",
    borderStyle: "solid",
    paddingTop: "12px",
    paddingBottom: "12px",
    paddingLeft: "20px",
    paddingRight: "20px",
    borderRadius: "5px",
    borderColor: "gray"
  }
};

LandingNavbar.propTypes = {
  layout: PropTypes.string,
  stickyTop: PropTypes.bool,
};

export default LandingNavbar;
